<template>
  <v-app>
    <v-main :class="fontStore.mainStyle" :style="{ fontSize: fontStore.fontSize + 'px', lineHeight: fontStore.fontSize + 'px' }">
        <show-component/>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

import {useCounterStore} from "@/store";
import ShowComponent from "@/components/layout/ShowComponent.vue";

export default {
  name: 'App',
    components: {ShowComponent},

  setup () {
      const fontStore = useCounterStore();
      return {
          fontStore
      }
  }
}
</script>

